import { getBorderToken } from "../fundations/palette/colorTokens";
export const Card = {
    MuiCard: {
        defaultProps: {
            elevation: 1
        },
        styleOverrides: {
            root: ({ theme })=>({
                    border: `1px solid ${getBorderToken("border200", theme)}`,
                    "&.MuiPaper-root": {
                        backgroundImage: "none"
                    }
                })
        }
    },
    MuiCardHeader: {
        styleOverrides: {
            root: ({ theme })=>({
                    padding: theme.spacing(2.5)
                })
        }
    },
    MuiCardContent: {
        styleOverrides: {
            root: ({ theme })=>({
                    padding: theme.spacing(2.5)
                })
        }
    },
    MuiCardActions: {
        styleOverrides: {
            root: ({ theme })=>({
                    padding: theme.spacing(2.5)
                })
        }
    }
};

//# sourceMappingURL=Card.js.map